export default "__VITE_ASSET__75bd46d4__"